// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"706":"release-notes","824":"release-notes-admin"}[chunkId] || chunkId) + "." + {"56":"015d6a4b","156":"7287efc2","165":"d358e470","303":"ce1b625d","319":"92226645","520":"3cc91d99","706":"7f930410","737":"22c59e7a","824":"68f10561","848":"b5212ccd","898":"1e9d4a51","936":"2763f45e"}[chunkId] + ".js";
};